/* Publish by EComposer at 2026-10-23 14:16:52*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wq8u17w4w5"]=  window.__ectimmers["ecom-wq8u17w4w5"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-wq8u17w4w5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wq8u17w4w5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mtqcld48c5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mtqcld48c5o', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}